import { useState,useEffect } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery } from "@tanstack/react-query";

import { SaveButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, kpiTeamValidation } from "./kpi-team-schema";
import { getKPITeam, editKPITeam } from "services/data.kpi.service";
import KPITeamInfo from "./components/KPITeamInfo";
import { useLocation } from "react-router-dom";

function EditKPITeam() {
  const location = useLocation();
  const { id } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null)
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  // useQuery({
  //   queryKey: ["kpi-team", { id }],
  //   queryFn: () => getKPITeam({ id }),
  //   onSuccess: (data) => setFormValues(data.data.data),
  //   onError,
  // });

  useQuery({
    queryKey: ["kpi-team", { id }],
    queryFn: () => getKPITeam({ id }),
    onSuccess: (data) => {
      const raw = data.data.data;
  
      const transformed = {
        ...raw,
        customerCode: raw.customerList?.split(",") || [], // 👈 ensure it's an array
        // productivity: raw.productivityRangeId
        //   ? { label: findLabelById(raw.productivityRangeId), value: raw.productivityRangeId }
        //   : null,
        // user: raw.userRangeId
        //   ? { label: findUserLabelById(raw.userRangeId), value: raw.userRangeId }
        //   : null,
      };
  
      setFormValues(transformed);
    },
    onError,
  });
  

  const editKPITeamMutation = useMutation(editKPITeam, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: {
      ...initialValues,
      range: "0;0,0;0,0;0,0;0"
    },
    resolver: yupResolver(kpiTeamValidation),
  });
  
 

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, isSubmitting },
    setValue,
    reset,
  } = form;

   // NEW: reset form once API returns data
   useEffect(() => {
    if (formValues) {
      console.log(formValues,'from form value');
      const transformedValues = {
        ...formValues,
        user: {
          label: formValues.user,
          value: formValues.userRangeId,
        },
        productivity: {
          label: formValues.productivity,
          value: formValues.productivityRangeId,
        },
        // user: { label: formValues.user, value: formValues.user },
        // productivity: { label: formValues.productivity, value: formValues.productivity }
      };
      reset(transformedValues);
    }
  }, [formValues, reset]);

  //  useEffect(() => {
  //   if (formValues) {
  //     reset(formValues);
  //   }
  // }, [formValues, reset]);

  const infoProps = {
    mode: "EDIT",
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    console.log(data);
    
    editKPITeamMutation.mutate({
      id: id,  
      team: data.team,
      customercode: data.customerCode,
      user: data.user.value,
      productivity: data.productivity.value,
      userrangeid: data.user.value,
      productivityrangeid: data.productivity.value
    }, {
      onSuccess: () => {
      },
    });
  };
  const editStatus = editKPITeamMutation.status === "loading";
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <KPITeamInfo {...infoProps} />
        <SaveButton label="Save" disabled={!isDirty && editStatus} url="/kpi/kpi-team" />
      </form>
    </Layout>
  );
}

export default EditKPITeam;
